(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .factory('ShowcaseLayoutTemplateFactory', ShowcaseLayoutTemplateFactory);

    ShowcaseLayoutTemplateFactory.$inject = ['$resource'];

    function ShowcaseLayoutTemplateFactory($resource) {
        var templateUrl = 'flyer/api/v2/showcase-layout-template/:id';
        var componentUrl = 'flyer/api/v2/showcase-layout-component/:componentId';
        var viewComponentUrl = 'flyer/api/v2/view-component';

        var TemplateResource = $resource(templateUrl, { id: '@id' }, {
            create: { method: 'POST', url: 'flyer/api/v2/showcase-layout-template' },
            update: { method: 'PUT' },
            delete: {
                method: 'DELETE',
                transformResponse: textOrJsonTransform
            },
            setStatus: {
                method: 'PUT',
                url: 'flyer/api/v2/showcase-layout-template/:id/status/:status'
            },
            query: {
                method: 'GET',
                isArray: true,
                url: 'flyer/api/v2/showcase-layout-template',
                transformResponse: paginatedListTransform
            }
        });

        var ComponentResource = $resource(componentUrl, { componentId: '@componentId' }, {
            queryByTemplate: {
                method: 'GET',
                isArray: true,
                url: 'flyer/api/v2/showcase-layout-component/template/:templateId',
                transformResponse: paginatedListTransform
            },
            delete: { method: 'DELETE' }
        });

        var ViewComponentResource = $resource(viewComponentUrl, {}, {
            getAll: { method: 'GET', isArray: true }
        });

        var StoreBannerResource = $resource('flyer/api/v2/showcase-banner', {}, {
            list: {
                method: 'GET',
                isArray: true,
                transformResponse: paginatedListTransform
            },
            listByIds: {
                method: 'GET',
                isArray: true,
                url: 'flyer/api/v2/showcase-banner/by-ids',
                params: { ids: '@ids' }
            },
            create: { method: 'POST' }
        });

        return {
            TemplateResource: TemplateResource,
            ComponentResource: ComponentResource,
            ViewComponentResource: ViewComponentResource,
            StoreBannerResource: StoreBannerResource
        };

        function paginatedListTransform(data, headersGetter) {
            var items = data ? angular.fromJson(data) : [];
            items.$headers = headersGetter;
            return items;
        }

        function textOrJsonTransform(data) {
            if (data === undefined || data === null || data === '') {
                return null;
            }
            if (angular.isObject(data)) {
                return data;
            }
            try {
                return angular.fromJson(data);
            } catch (e) {
                // Texto puro (ex.: erro 409) — objeto evita re-parse do transformador padrão do $http
                return { message: data };
            }
        }
    }

})();
